export enum TOKEN {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  KC_TOKEN = 'id_token',
}

export enum USER_ROLE {
  ADMIN = 'ADMIN',
  SALES = 'SALE',
  TICKETING = 'TICKETING',
  ACCOUNTING = 'ACCOUNTING',
  CONTENT = 'CONTENT',
}
